<div class="kpi-statistics-card-container" *ngIf="statistic" ui-row uiAlign="middle" uiJustify="center" data-test-id="kpi-details-statistic-cards-field">
  <div ui-col>
    <div ui-row uiJustify="center">
      <div class="statistic-value" *ngIf="!isEmptyState" ui-col>{{ statistic.value }}</div>
      <div *ngIf="!isEmptyState" ui-col>
        <progress-indicator-label
          [deltaPercentage]="statistic.progressIndicatorData.deltaPercentage"
          [lessIsBetter]="statistic.progressIndicatorData.lessIsBetter"
          [isAccent]="true"></progress-indicator-label>
      </div>
      <div class="empty-state" *ngIf="isEmptyState" ui-col>{{ "no_data_available" | localize }}</div>
    </div>
    <div class="comparison-label" ui-row uiJustify="center">{{ statistic.comparisonLabel }}</div>
  </div>
</div>
